import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCardText } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ax-dialog',{ref:"dialog",attrs:{"title":"Share","icon":"mdi-share-variant-outline","size":"small"},on:{"shown":_vm.onShow,"submitted":_vm.onSubmit}},[_c('template',{slot:"content"},[_c(VCardText,[_c(VAutocomplete,{attrs:{"label":"Select user(s)","items":_vm.users.list,"multiple":"","chips":""},model:{value:(_vm.users.selected),callback:function ($$v) {_vm.$set(_vm.users, "selected", $$v)},expression:"users.selected"}})],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }